import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Observable, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MpsApiService {
  private http = inject(HttpClient);

  constructor(@Inject('API_BASE_URL') private baseUrl: string) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get<T>(resource: string, params: any = {}): Observable<T> {
    params.headers = new HttpHeaders({
      'Accept-Language': 'fr, en',
    });

    return this.http.get<T>(this.baseUrl + '/' + resource, params).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  post<T, TResponse>(resource: string, params?: T, options: any = {}): Observable<TResponse> {
    if (!resource.indexOf('register')) {
      options.headers = new HttpHeaders({
        'Accept-Language': 'fr, en',
      });
    }
    return this.http.post<T>(this.baseUrl + '/' + resource, params, options).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  patch<T, TResponse>(resource: string, params?: T, options: any = {}): Observable<TResponse> {
    return this.http.patch<T>(this.baseUrl + '/' + resource, params, options).pipe(catchError(this.handleError));
  }

  delete<T>(resource: string, params?: object): Observable<T> {
    return this.http.delete<T>(this.baseUrl + '/' + resource, params).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadFile<T>(resource: string, file: File, options: any = {}): Observable<T> {
    if (!resource.indexOf('register')) {
      options.headers = new HttpHeaders({
        'Accept-Language': 'fr, en',
      });
    }
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<T>(this.baseUrl + '/' + resource, formData, options).pipe(catchError(this.handleError));
  }

  getFile<T>(resource: string): Observable<T> {
    const httpOptions: object = { responseType: 'blob' };

    return this.http.get<T>(this.baseUrl + '/' + resource, httpOptions).pipe(catchError(this.handleError));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleError(error: any): Promise<any> {
    if (error.status === 401) {
      return Promise.reject(error);
    }
    if (error.status === 422) {
      return Promise.reject(error.error.message || error.message || error);
    }
    return Promise.reject(error.error.message || error.message || error);
  }
}
